import React, { Component } from 'react';
import FieldModal from '../../../components/modals/fieldModal';
import InputField from '../../../components/inputs/inputField';
import ToggleField from '../../../components/inputs/toggleField';

class AddVirtualLinkModal extends Component {
    constructor(props) {
        super(props);
        const { linkData, mode } = props;
        this.state = {
            name: mode === 'edit' && linkData ? linkData.name : '',
            url: mode === 'edit' && linkData ? linkData.url : '',
            linkType: mode === 'edit' && linkData && linkData.channelBroadcast?.arn ? 'aws' : 'custom',
            channelName: mode === 'edit' && linkData ? linkData.name : '',
            errors: {}
        };
    }

    handleInputChange = (field, value) => {
        this.setState({
            [field]: value,
            errors: {
                ...this.state.errors,
                [field]: null
            }
        });
    };

    validateForm = () => {
        const { name, url, linkType, channelName } = this.state;
        const errors = {};

        if (linkType === 'custom') {
            if (!name || name.trim() === '') {
                errors.name = 'Name is required';
            }
            if (!url || url.trim() === '') {
                errors.url = 'URL is required';
            } else {
                // Basic URL validation
                const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
                if (!urlPattern.test(url) && !url.startsWith('http://') && !url.startsWith('https://')) {
                    // Try adding https:// prefix and validate again
                    const urlWithPrefix = 'https://' + url;
                    if (!urlPattern.test(urlWithPrefix)) {
                        errors.url = 'Please enter a valid URL';
                    }
                }
                if (!errors.url) {
                    const { existingLinks = [], linkData, mode } = this.props;
                    let formattedUrl = url.trim();
                    if (!formattedUrl.startsWith('http://') && !formattedUrl.startsWith('https://')) {
                        formattedUrl = 'https://' + formattedUrl;
                    }
                    const duplicate = existingLinks.find(link =>
                        link.url === formattedUrl &&
                        (mode !== 'edit' || link._id !== linkData._id)
                    );
                    if (duplicate) {
                        errors.url = 'A virtual link with this URL already exists';
                    }
                }            }
        } else if (linkType === 'aws') {
            if (!channelName || channelName.trim() === '') {
                errors.channelName = 'AWS Channel name is required';
            }
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSave = () => {
        if (this.validateForm()) {
            const { name, url, linkType, channelName } = this.state;
            
            const linkData = {
                linkType: linkType
            };

            if (linkType === 'custom') {
                linkData.name = name.trim();
                // Ensure URL has protocol
                let formattedUrl = url.trim();
                if (!formattedUrl.startsWith('http://') && !formattedUrl.startsWith('https://')) {
                    formattedUrl = 'https://' + formattedUrl;
                }
                linkData.url = formattedUrl;
            } else if (linkType === 'aws') {
                linkData.name = channelName.trim();
            }
            
            this.props.onSave(linkData);
        }
    };

    renderBody = () => {
        const { name, url, linkType, channelName, errors } = this.state;
        const { mode, linkData } = this.props;
        const isEdit = mode === 'edit';
        const isAwsLink = isEdit && linkData && !!linkData.channelBroadcast?.arn;

        return (
            <div className="flex column gap15 w-100">
                {/* Link Type Toggle - Only show when creating new link */}
                {!isEdit && (
                    <ToggleField
                        label="Use AWS Channel"
                        checked={linkType === 'aws'}
                        onChange={(e) => this.handleInputChange('linkType', e.target.checked ? 'aws' : 'custom')}
                        helpText="Toggle on for AWS IVS Channel, off for custom URL"
                        icons={false}
                    />
                )}

                {/* Conditional Fields - Mutually Exclusive */}
                {linkType === 'custom' && (
                    <>
                        <InputField
                            label="Name"
                            placeholder="Enter link name"
                            value={name}
                            onChange={(e) => this.handleInputChange('name', e.target.value)}
                            errorTrigger={errors.name}
                            required={true}
                        />
                        <InputField
                            label="URL"
                            placeholder="https://example.com"
                            value={url}
                            onChange={(e) => this.handleInputChange('url', e.target.value)}
                            errorTrigger={errors.url}
                            errorMessage={errors.url}
                            required={true}
                        />
                    </>
                )}

                {linkType === 'aws' && (
                    <>
                        <InputField
                            label="AWS Channel Name"
                            placeholder="Enter channel name"
                            value={channelName}
                            onChange={(e) => this.handleInputChange('channelName', e.target.value)}
                            errorTrigger={errors.channelName}
                            errorMessage={errors.channelName}
                            required={true}
                        />
                        {isEdit && (
                            <InputField
                                label="URL"
                                value={url || ''}
                                disabled={true}
                                inputIcon={<i className="las la-lock" />}
                                placeholder="URL will be generated automatically"
                                inputStyle={{ overflow: 'hidden !important', textOverflow: 'unset !important', color: 'var(--outline-border)', paddingRight: '30px' }}
                            />
                        )}
                    </>
                )}
            </div>
        );
    };

    render() {
        const { isOpen, toggle, mode } = this.props;
        const isEdit = mode === 'edit';

        return (
            <FieldModal
                isOpen={isOpen}
                toggle={toggle}
                modalTitle={isEdit ? 'Edit Virtual Link' : 'Add Virtual Link'}
                size="small"
                overflowOff={true}
                bodyContent={this.renderBody}
                actionButton={this.handleSave}
                actionButtonLabel={isEdit ? 'Save Changes' : 'Add Link'}
                className="modal-dialog-centered"
            />
        );
    }
}

export default AddVirtualLinkModal;